@import "src/styles/common/_colors.scss";

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loadingSpinner {
  width: 50px;
  height: 50px;
  border: 10px solid $white-variant-1;
  /* Light grey */
  border-top: 10px solid $mightnight-black;
  /* Black */
  border-radius: 50%;
  animation: spinner 1.5s linear infinite;
  position: relative;
}

.spinnerContainer {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $mightnight-black;
  opacity: 0.5;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
}

.exportLoader {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 600;

  .exportLoaderBackdrop.exportLoader {
    left: 0;
    top: 0;
    position: absolute;
    height: 100%;
  }

  .exportLoaderWrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 700;
  }
}

.exportLoaderBackdrop {
  background: $backdrop-color;
  opacity: 0.6;
}

.exportLoaderBody {
  display: inline-block;
  position: relative;
  color: $white;
  background: $dialog-background-color;
  min-width: 300px;
  padding: 20px;
  text-align: left;
  border-radius: 7px;
  z-index: 601;
  font-size: 11px;

  .cancelLink {
    background: none;
    color: $white;
    text-decoration: underline;
    float: right;
    cursor: pointer;
    border: none;
    box-shadow: none;
    & :hover {
      color: $dark-green;
    }
  }
}

@-webkit-keyframes animate-stripes {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 60px 0;
  }
}

@keyframes animate-stripes {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 60px 0;
  }
}

.progress {
  height: 14px;
  background: $green-variant-1;
  border: 2px solid $green-variant-2;
  background-image: none;
  border-radius: 2px;
  margin-top: 10px;
  margin-bottom: 10px;
  transition: width 800ms;
}

.progressBar {
  height: 10px;
  background-size: 6px 6px;
  background-image: linear-gradient(
    135deg,
    $black 26%,
    transparent 25%,
    transparent 51%,
    $black 49%,
    $black 75%,
    transparent 75%,
    transparent
  );
  animation: animate-stripes 2s linear infinite;
  -webkit-animation: animate-stripes 2s linear infinite;
  opacity: 0.5;
}
